import { NativeStackHeaderProps, router } from 'expo-router';
import React from 'react';
import Icon from 'shared/components/vxl/icon/Icon/Icon';
import {
  NavBarProps,
  NavigationBar,
} from 'shared/components/vxl/navigation/NavigationBar/NavigationBar';
import theme from 'shared/styles/theme';
import { isNotNil } from 'shared/utils/isNotNil/isNotNil';

export interface ExpoNavigationBarProps
  extends
    NativeStackHeaderProps,
    Omit<NavBarProps, 'title' | 'primaryOnPress'> {
  primaryOnPress?: () => void;
}

const ExpoNavigationBar = ({
  options,
  navigation,
  primaryOnPress,
  isPrimaryDisabled = false,
  ...restProps
}: ExpoNavigationBarProps) => {
  const { title, headerBackVisible } = options;
  const canGoBack = (headerBackVisible ?? false) && navigation.canGoBack();

  const handlePrimaryOnPress = isNotNil(primaryOnPress)
    ? primaryOnPress
    : () => {
        if (canGoBack) {
          navigation.goBack();
        } else {
          router.replace('/(authenticated)/(tabs)');
        }
      };

  const isLoginPage =
    navigation?.getState()?.routes?.[0]?.name === 'login/index';

  const backIconColor = isPrimaryDisabled
    ? theme.color.interactive.disabled.text
    : undefined;

  return (
    <NavigationBar
      title={title}
      primaryIcon={
        !isLoginPage ? (
          <Icon iconKey="BACK" iconSize="MD" iconColor={backIconColor} />
        ) : null
      }
      primaryOnPress={handlePrimaryOnPress}
      isPrimaryDisabled={isPrimaryDisabled}
      {...restProps}
    />
  );
};

export default ExpoNavigationBar;
